(() => {
  const pushEvent = (eventName, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...detail });
  };

  document.addEventListener("click", (event) => {
    const target = event.target.closest(".amazon-sns-campaign [data-event]");
    if (!target) return;
    if (target.getAttribute("aria-disabled") === "true") return;
    pushEvent(target.dataset.event, {
      campaign_name: "amazon_sns_cashback_2026",
      link_url: target.href || undefined,
      location: target.dataset.location || undefined,
      item_id: target.dataset.sku || undefined,
    });
  });

  document.querySelectorAll(".amazon-sns-campaign .faq details").forEach((item, index) => {
    item.addEventListener("toggle", () => {
      if (!item.open) return;
      pushEvent("campaign_faq_open", {
        campaign_name: "amazon_sns_cashback_2026",
        faq_index: index + 1,
        faq_question: item.querySelector("summary")?.textContent?.trim(),
      });
    });
  });

})();
